import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import CheckboxChecked from 'wix-ui-icons-common/system/CheckboxChecked';
import CheckboxIndeterminate from 'wix-ui-icons-common/system/CheckboxIndeterminate';
import { st, classes } from './Checkbox.st.css';
import Text from '../Text';
import { withFocusable } from "wix-ui-core/dist/es/src/hocs/Focusable/FocusableHOC";
import deprecationLog from '../utils/deprecationLog';
import { generateID } from '../utils/generateId';
import Tooltip from '../Tooltip';
import * as DATA_ATTR from './DataAttr';
import { dataHooks } from './constants';
import { TooltipCommonProps } from '../common/PropTypes/TooltipCommon';
/** a simple WixStyle checkbox */

var Checkbox = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Checkbox, _React$PureComponent);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_id", "".concat(Checkbox.displayName, "-").concat(generateID()));

    _defineProperty(_assertThisInitialized(_this), "_getDataAttributes", function () {
      var _ref;

      var _this$props = _this.props,
          checked = _this$props.checked,
          indeterminate = _this$props.indeterminate,
          disabled = _this$props.disabled,
          hasError = _this$props.hasError;
      return _ref = {}, _defineProperty(_ref, DATA_ATTR.DATA_CHECK_TYPE, indeterminate ? DATA_ATTR.CHECK_TYPES.INDETERMINATE : checked ? DATA_ATTR.CHECK_TYPES.CHECKED : DATA_ATTR.CHECK_TYPES.UNCHECKED), _defineProperty(_ref, DATA_ATTR.DATA_HAS_ERROR, hasError && !disabled), _defineProperty(_ref, DATA_ATTR.DATA_DISABLED, disabled), _ref;
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? this._id : _this$props2$id,
          checked = _this$props2.checked,
          indeterminate = _this$props2.indeterminate,
          disabled = _this$props2.disabled,
          hasError = _this$props2.hasError,
          errorMessage = _this$props2.errorMessage,
          selectionArea = _this$props2.selectionArea,
          vAlign = _this$props2.vAlign,
          size = _this$props2.size,
          onChange = _this$props2.onChange,
          children = _this$props2.children,
          dataHook = _this$props2.dataHook,
          focusableOnFocus = _this$props2.focusableOnFocus,
          focusableOnBlur = _this$props2.focusableOnBlur,
          className = _this$props2.className,
          tooltipProps = _this$props2.tooltipProps,
          tooltipContent = _this$props2.tooltipContent,
          selectionAreaSkin = _this$props2.selectionAreaSkin,
          selectionAreaPadding = _this$props2.selectionAreaPadding;

      if (errorMessage) {
        deprecationLog('<Checkbox/> - errorMessage prop is deprecated and will be removed in next major release, please use tooltipContent instead');
      }

      var isTooltipDisabled = tooltipProps && tooltipProps.disabled || disabled || !tooltipContent && (!hasError || !errorMessage);
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-hook": dataHook,
        className: st(classes.root, {
          vAlign: vAlign,
          selectionArea: selectionArea,
          selectionAreaSkin: selectionAreaSkin,
          disabled: disabled,
          error: hasError && !disabled,
          selection: indeterminate ? 'indeterminate' : checked ? 'checked' : 'unchecked',
          indeterminate: indeterminate
        }, className),
        onFocus: focusableOnFocus,
        onBlur: focusableOnBlur,
        tabIndex: disabled ? null : 0
      }, this._getDataAttributes()), /*#__PURE__*/React.createElement("input", {
        "data-hook": dataHooks.input,
        type: "checkbox",
        id: id,
        checked: checked,
        disabled: disabled,
        onChange: disabled ? null : onChange,
        style: {
          display: 'none'
        }
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        "data-hook": dataHooks.label,
        className: classes.label
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.labelInner,
        style: {
          padding: selectionAreaPadding
        }
      }, /*#__PURE__*/React.createElement(Tooltip, _extends({
        dataHook: dataHooks.boxTooltip,
        disabled: isTooltipDisabled,
        content: tooltipContent || errorMessage || ' ',
        textAlign: "center",
        maxWidth: 230,
        hideDelay: 150,
        zIndex: 10000
      }, tooltipProps), /*#__PURE__*/React.createElement("div", {
        className: classes.outer
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHooks.box,
        className: classes.checkbox
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.inner,
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, indeterminate ? /*#__PURE__*/React.createElement(CheckboxIndeterminate, null) : /*#__PURE__*/React.createElement(CheckboxChecked, null))))), children && /*#__PURE__*/React.createElement(Text, {
        size: size,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        skin: disabled ? 'disabled' : 'standard',
        weight: "thin",
        dataHook: dataHooks.children,
        className: classes.children
      }, children))));
    }
  }]);

  return Checkbox;
}(React.PureComponent);

Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** used for automatic testing */
  checked: PropTypes.bool,
  children: PropTypes.node,

  /** Is checkbox disabled */
  disabled: PropTypes.bool,

  /** Does checkbox has an error */
  hasError: PropTypes.bool,
  id: PropTypes.string,

  /** Checkbox is in an indeterminate state */
  indeterminate: PropTypes.bool,

  /**
   * The error message when there's an error
   * @deprecated
   * */
  errorMessage: PropTypes.string,

  /** Selection area emphasises the clickable area, none means no emphasis, hover is when the mouse is on the component, and always will show constantly */
  selectionArea: PropTypes.oneOf(['none', 'hover', 'always']),

  /** Positioning of the checkbox compared to the label */
  vAlign: PropTypes.oneOf(['center', 'top']),

  /** used for automatic testing */
  hover: PropTypes.bool,

  /** Size of the checkbox label */
  size: PropTypes.oneOf(['small', 'medium']),

  /** A callback function triggered when the checkbox state is changed */
  onChange: PropTypes.func,

  /** Define styles through a classname */
  className: PropTypes.string,

  /** Selection area skin emphasises the style of the clickable area for selectionArea ('hover' or 'always'),  filled (default) means selectionArea has backgound, outlined means selectionArea has outline */
  selectionAreaSkin: PropTypes.oneOf(['filled', 'outlined']),

  /** Selection area padding emphasises the padding of the clickable area, empty means default padding, not empty overrides the default padding*/
  selectionAreaPadding: PropTypes.string,

  /** Tooltip content. Can be either string or renderable node */
  tooltipContent: PropTypes.node,

  /** Tooltip props, common for all tooltips */
  tooltipProps: PropTypes.shape(TooltipCommonProps)
};
Checkbox.defaultProps = {
  checked: false,
  size: 'medium',
  selectionArea: 'none',
  vAlign: 'center',
  onChange: function onChange(e) {
    return e.stopPropagation();
  },
  hasError: false,
  disabled: false,
  indeterminate: false,
  selectionAreaSkin: 'filled'
};
export default withFocusable(Checkbox);